'use client'
// Compteur animé : défile (ease-out cubic) et s'arrête sur la vraie valeur.
import { useState, useEffect, useRef } from 'react'

export function useCountUp(target: number, duration = 1400, start = true) {
  const [val, setVal] = useState(0)
  const done = useRef(false)
  useEffect(() => {
    if (!start || done.current) return
    if (target === 0) { setVal(0); return }
    done.current = true
    let raf = 0
    const t0 = performance.now()
    const tick = (t: number) => {
      const p = Math.min((t - t0) / duration, 1)
      const eased = 1 - Math.pow(1 - p, 3)   // ralentit en approchant de la cible
      setVal(Math.round(target * eased))
      if (p < 1) raf = requestAnimationFrame(tick)
    }
    raf = requestAnimationFrame(tick)
    return () => cancelAnimationFrame(raf)
  }, [target, duration, start])
  return val
}
